import { Box, Grid, Typography, MenuItem } from "@mui/material";
import { Formik, Form, Field, ErrorMessage } from "formik";
import TextField from "@mui/material/TextField";
import FormSelectField from "../common/FormSelectField";
import FormInput from "./FormInput";
import { addStaffInitialValues } from "../forms/initialValues";

interface IProps {
  initialValue?: any;
  isEdited?: boolean;
  handleSubmit: (values: any) => void;
  data: any;
  validationSchema?: any;
}

const ReusableForm = ({
  handleSubmit,
  initialValue = addStaffInitialValues,
  data,
  validationSchema,
  isEdited
}: IProps) => {
  
  return (
    <>
      <Formik
        initialValues={initialValue}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ errors, touched }) => (
          <Form>
            <Box sx={{ mt: 1 }}>
              <Grid container spacing={2}>
                {data.map((item: any) => (
                  <Grid
                    item
                    xs={item.pinType ? 3 : 12}
                    sm={item.pinType ? 3 : 6}
                    key={item.id}
                  >
                    <Typography variant="h6" gutterBottom>
                      {item.title}
                    </Typography>
                    {item.type === "select" ? (
                      <FormSelectField
                        name={item?.name}
                        defaultValue01={initialValue?.role_id}
                        data={item?.options}
                        placeholder={isEdited ? null : item?.placeholder}
                        labelId="speciality-dropdown"
                      />
                    ) : (
                      <FormInput
                        name={item.name}
                        type={item.type}
                        placeholder={isEdited ? null : item.placeholder}
                        as={TextField}
                        fullWidth
                      />
                    )}
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default ReusableForm;
